import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert, Col, Row, Select, Spin, Typography } from 'antd'
import { __product } from '../__product'
import i from '../../../../translations/i'
import { openApi } from '../../../../helpers/request'
import { ModifierRestrictions, ModifierRules } from './ModifierRestrictions'

export const ProductModifiers = observer(() => {
    const productId = Number(__product.item.id)
    const [selectedId, setSelectedId] = useState(productId)
    const [variant, setVariant] = useState<any>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        __product.getModifiersGroups()
    }, [])

    useEffect(() => setSelectedId(productId), [productId])

    useEffect(() => {
        let active = true
        setError(false)
        setVariant(null)
        if (!selectedId || selectedId === productId) {
            setLoading(false)
            return
        }
        setLoading(true)
        openApi('get', `/products/${selectedId}?with[]=modifiers_groups_all`, {}, undefined, true)
            .then(result => { if (active) setVariant(result.data) })
            .catch(() => { if (active) setError(true) })
            .finally(() => { if (active) setLoading(false) })
        return () => { active = false }
    }, [selectedId, productId])

    const variations = Array.isArray(__product.item.variations) ? __product.item.variations : []
    const savedGroups: ModifierRules[] = Array.isArray(__product.item.modifiers_groups_all) ? __product.item.modifiers_groups_all : []
    const groups: ModifierRules[] = selectedId === productId
        ? (__product.item.modifiers_groups ?? []).map((id: number) => savedGroups.find(group => group.id === id)
            ?? __product.modifiers_groups.find((group: ModifierRules) => group.id === id)).filter(Boolean)
        : (variant?.id === selectedId && Array.isArray(variant.modifiers_groups_all) ? variant.modifiers_groups_all : [])

    return (
        <Row gutter={[20, 20]}>
            <Col span={24}>
                <label className="formLabel">{i.t('modifier:groups')}</label>

                <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    style={{ width: '100%' }}
                    placeholder={i.t('product:selectModifierGroups')}
                    value={__product.item.modifiers_groups}
                    options={__product.modifiers_groups.map((group: any) => ({
                        label: group.name,
                        value: group.id,
                    }))}
                    filterOption={(input, option: any) => {
                        return String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }}
                    onChange={(values) => {
                        __product.item.modifiers_groups = values
                    }}
                />
            </Col>
            <Col span={24}>
                <Typography.Title level={5}>{i.t('modifiersGroup:rulesTitle')}</Typography.Title>
                <Typography.Paragraph type="secondary">{i.t('modifiersGroup:rulesHint')}</Typography.Paragraph>
                {variations.length > 0 && <Select
                    aria-label={i.t('modifiersGroup:rulesTarget')}
                    style={{ width: '100%', marginBottom: 16 }}
                    value={selectedId}
                    onChange={setSelectedId}
                    options={[__product.item, ...variations].map(product => ({
                        value: Number(product.id), label: `${product.name} · #${product.id}`,
                    }))}
                />}
                {error ? <Alert type="error" showIcon message={i.t('modifiersGroup:rulesLoadError')} />
                    : loading ? <Spin /> : <ModifierRestrictions groups={groups} />}
            </Col>
        </Row>
    )
})
